export enum SeverityLevel {
  Low = '轻微',
  Medium = '中等',
  High = '严重'
}
